import { React, Component } from 'react';
import DoubleArrowOutlinedIcon from '@material-ui/icons/DoubleArrowOutlined';

export class BotaoIrParaBaixo extends Component {

    render() {
        return (
            <div className="carousel-caption d-md-block next-item">
                <a id='button-baixo' className='BtnIrParaBaixo' aria-label="ir para Blogs" href="#titulo-blogs">
                    <DoubleArrowOutlinedIcon className="iconDown" />
                </a>
            </div>
        )
    }

}

export default BotaoIrParaBaixo;